<template>
  <v-data-table
    :headers="headers"
    :items="solicitudes"
    sort-by="calories"
    class="elevation-1"
    :search="search"
    v-if="logueado"
  >
    <template v-slot:top>
      <v-toolbar flat class="mt-5 mb-3">
        <v-img
          class="mr-3"
          :src="logoCuenta"
          max-width="100"
          max-height="100"
          contain
        ></v-img>
        <v-toolbar-title>Solicitudes de grabaciones</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-breadcrumbs :items="itemsBreadcrumbs" divider="/"></v-breadcrumbs>
        <v-spacer></v-spacer>
        <v-text-field
          class="text-xs-center"
          v-model="search"
          append-icon="fas fa-search"
          label="Busqueda"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="$router.push({ name: 'TicketGrabacion' })"
        >
          Nueva solicitud
        </v-btn>

        <v-dialog v-model="dialog" max-width="800px" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <p class="body-1 text--secondary ml-5">Campos editables *</p>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="fechaSolicitud"
                      label="Fecha solictud"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="fechaAsistencia"
                      label="Fecha asistencia *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="numeroAsistencia"
                      label="Numero asistencia"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="nombre"
                      label="Nombre Asegurado *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="placa"
                      label="Placa *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="marca"
                      label="Marca *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="modelo"
                      label="Modelo *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="solicitadaNombre"
                      label="Solicitada por nombre *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-textarea
                      v-model="motivoSolicitud"
                      label="Motivo de petición de llamada *"
                      outlined
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-list dense class="py-0">
                      <v-subheader class="title">Mis archivos</v-subheader>
                      <v-divider></v-divider>
                      <v-list-item-group color="primary">
                        <v-list-item
                          v-for="(item, i) in archivosMotivo"
                          :key="i"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.nombre
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action class="ma-0">
                            <v-btn icon @click="eliminarArchivo(item)">
                              <v-icon
                                color="black"
                                class="far fa-trash-alt"
                              ></v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-subheader class="title px-2"
                      >Cargar archivos</v-subheader
                    >
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12">
                    <VueFileAgent
                      v-model="fileRecords"
                      :deletable="true"
                      :multiple="true"
                      :meta="true"
                      @select="filesSelected($event)"
                      @beforedelete="onBeforeDelete($event)"
                    ></VueFileAgent>
                  </v-col>
                  <v-col>
                    <v-btn color="primary" @click="cargarArchivos()"
                      >Cargar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                  <v-col>
                    <h2>Respuesta de Asistencia Regional</h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="fechaEnvio"
                      label="Fecha de envío"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="nombreQuienEnvio"
                      label="Nombre de quien envió"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Observaciones</v-card-title>
                      <v-list
                        class="py-0"
                        dense
                        v-for="(item, index) in itemsObservaciones"
                        :key="index"
                      >
                        <v-list-item>
                          <v-list-item-content>
                            <p>{{ item }}</p>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="index"></v-divider>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p class="headline" v-if="archivos.length > 0">
                      {{ archivos.length }} Archivo(s) adjunto(s)
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cerrar </v-btn>
              <v-btn color="blue darken-1" text @click="actualizar">
                Actualizar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="generarZip"
                :disabled="cantidadArchivos <= 0"
                >Descargar archivos</v-btn
              >
            </v-card-actions>
          </v-card>
          <v-overlay v-model="loading">
            <lottie-player
              autoplay
              loop
              mode="normal"
              src="https://assets7.lottiefiles.com/packages/lf20_OdNgAj.json"
              style="width: 500px"
              background="transparent"
            >
            </lottie-player>
          </v-overlay>
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small @click="editItem(item)"> fas fa-eye </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" outlined @click="inicializar"> Recargar </v-btn>
    </template>
    <template v-slot:[`item.estado`]="{ item }">
      <v-chip :color="colorEstado(item.estado)">
        <div v-if="item.estado">
          <span>{{ item.estado }}</span>
        </div>
        <div v-else>
          <span>{{ item.estado }}</span>
        </div>
      </v-chip>
      <v-overlay v-model="loadingTabla">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets7.lottiefiles.com/packages/lf20_OdNgAj.json"
          style="width: 500px"
          background="transparent"
        >
        </lottie-player>
      </v-overlay>
    </template>
  </v-data-table>
  <v-card v-else flat class="mx-auto my-auto">
    <div class="mt-5 display-1 text-center">Pagina no disponible</div>
    <v-card-text>
      <lottie-player
        autoplay
        mode="normal"
        src="https://assets5.lottiefiles.com/packages/lf20_shvej97v.json"
        style="width: 300px"
        background="transparent"
      >
      </lottie-player>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  dbRealtimeSoliGrabaciones,
  dbRealtimeUser,
  instanceWeb,
  dbStorage,
} from "../main";
import "@lottiefiles/lottie-player";
import router from "../router";
import axios from "axios";

export default {
  data: () => ({
    solicitudes: [],
    respuestaRegional: [],
    editedIndex: -1,
    dialog: false,
    search: "",
    headers: [
      {
        text: "Fecha solicitud",
        align: "center",
        sortable: true,
        value: "fechaSolicitud",
      },
      { text: "Fecha asistencia", value: "fechaAsistencia", align: "center" },
      { text: "Numero asistencia", value: "numeroAsistencia", align: "center" },
      {
        text: "Nombre asegurado",
        value: "nombre",
        align: "center",
        sortable: false,
      },
      { text: "Placa", value: "placa", align: "center", sortable: false },
      { text: "Marca", value: "marca", align: "center", sortable: false },
      { text: "Modelo", value: "modelo", align: "center", sortable: false },
      { text: "Estado", value: "estado", align: "center" },
      { text: "Opciones", value: "actions", align: "center", sortable: false },
    ],
    fechaSolicitud: "",
    fechaAsistencia: "",
    numeroAsistencia: "",
    nombre: "",
    placa: "",
    marca: "",
    modelo: "",
    motivoSolicitud: "",
    solicitadaNombre: "",
    fechaEnvio: "",
    observaciones: "",
    nombreQuienEnvio: "",
    estado: "",
    logueado: false,
    itemsBreadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        href: "login",
      },
      {
        text: "Solicitud de grabación",
        disabled: true,
        href: "SolicitudGrabacion",
      },
    ],
    cuenta: "",
    loading: false,
    loadingTabla: false,
    overlay: false,
    //manejo de archivos
    fileRecords: [],
    fileRecordsForUpload: [],
    cantidadArchivos: 0,
    nombreArchivos: [],
    nombreArchivosMotivo: [],
    archivos: [],
    archivosMotivo: [],
    itemsObservaciones: [],
    //telegram
    chatIdGrupo: -1001512403640,
    chatIdUsuario: 0,
    token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Detalles de solicitud";
    },
    logoCuenta() {
      switch (this.cuenta) {
        case "Assa":
          return require("@/assets/cliente11.jpg");
        case "Futuro":
          return require("@/assets/cliente05.jpg");
      }
    },
  },

  created() {
    this.verificarAuth();
  },

  methods: {
    verificarAuth() {
      let me = this;
      instanceWeb.auth().onAuthStateChanged(function (user) {
        if (user) {
          me.datosUsuario(user.uid);
        } else {
          router.push({ name: "Login" });
        }
      });
    },

    datosUsuario(id) {
      let me = this;
      dbRealtimeUser
        .child(id)
        .once("value")
        .then(function (dataSnapshot) {
          if (dataSnapshot.val().estado == "activo") {
            me.logueado = true;
            me.cuenta = dataSnapshot.val().cuenta;
            me.chatIdUsuario = dataSnapshot.val().idTelegram;
            me.inicializar(dataSnapshot.val().cuenta);
          } else {
            me.cerrarSesion();
          }
        });
    },

    cerrarSesion() {
      instanceWeb.auth().signOut();
      this.logueado = false;
    },

    inicializar(cuenta) {
      let me = this;
      me.loadingTabla = true;
      dbRealtimeSoliGrabaciones
        .child(cuenta)
        .on("value", function (dataSnapshot) {
          me.solicitudes = [];
          dataSnapshot.forEach((value) => {
            me.solicitudes.push(value.val());
          });
          me.loadingTabla = false;
        });
    },

    editItem(item) {
      if (item.observaciones) {
        this.itemsObservaciones = item.observaciones.split("~");
      }

      this.dialog = true;
      this.editedIndex = 0;
      this.fechaSolicitud = item.fechaSolicitud;
      this.fechaAsistencia = item.fechaAsistencia;
      this.numeroAsistencia = item.numeroAsistencia;
      this.nombre = item.nombre;
      this.placa = item.placa;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.motivoSolicitud = item.motivoSolicitud;
      this.solicitadaNombre = item.solicitadaNombre;
      this.fechaEnvio = item.fechaEnvio;
      this.observaciones = item.observaciones;
      this.nombreQuienEnvio = item.nombreQuienEnvio;
      this.cuenta = item.cuenta;

      this.verArchivos();
      this.verArchivosMotivo();
    },

    verArchivos() {
      let me = this;
      dbStorage
        .ref("SolicitudesGrabaciones/" + me.cuenta + "/" + me.numeroAsistencia)
        .list()
        .then(function (refImagen) {
          for (var i = 0; i < refImagen.items.length; i++) {
            let aux = refImagen.items[i].location.path.split("/");
            me.nombreArchivos[i] = aux[3];
          }
          me.cantidadArchivos = me.nombreArchivos.length;
          me.descargarArchivos();
        });
    },

    descargarArchivos() {
      let me = this;
      me.archivos = [];

      for (var i = 0; i < me.nombreArchivos.length; i++) {
        let auxNombre = me.nombreArchivos[i];
        dbStorage
          .ref(
            "SolicitudesGrabaciones/" +
              me.cuenta +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.nombreArchivos[i]
          )
          .getDownloadURL()
          .then(function (url) {
            let aux = url;
            me.archivos.push({
              nombre: auxNombre,
              url: aux,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    generarZip() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let archivo = zip.folder("archivos");

      me.loading = true;

      for (var i = 0; i < me.archivos.length; i++) {
        let nombre = me.archivos[i].nombre;
        let url = me.archivos[i].url;
        let contentP = me.downloadURLPromise(url);
        archivo.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, "Archivos" + ".zip");
        me.loading = false;
      });
    },

    downloadURLPromise(url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function (evt) {
          if (xhr.readyState === 4) {
            if (xhr.status == 200) {
              resolve(xhr.response);
            } else {
              reject(new Error("Error" + ":" + xhr.status));
            }
          }
        };
        xhr.send();
      });
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    actualizar() {
      let me = this;
      dbRealtimeSoliGrabaciones
        .child(me.cuenta)
        .child(me.numeroAsistencia)
        .update({
          fechaAsistencia: me.fechaAsistencia,
          nombre: me.nombre,
          placa: me.placa,
          marca: me.marca,
          modelo: me.modelo,
          solicitadaNombre: me.solicitadaNombre,
          motivoSolicitud: me.motivoSolicitud,
        })
        .then(function () {
          me.notificacionTelegram();
          me.dialog = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiar() {
      this.fechaSolicitud = "";
      this.fechaAsistencia = "";
      this.numeroAsistencia = "";
      this.nombre = "";
      this.placa = "";
      this.marca = "";
      this.modelo = "";
      this.motivoSolicitud = "";
      this.solicitadaNombre = "";
      this.fechaEnvio = "";
      this.observaciones = "";
      this.nombreQuienEnvio = "";
      this.estado = "";
      this.cantidadArchivos = 0;
      this.nombreArchivos = [];
      this.archivos = [];
      this.fileRecords = [];
      this.fileRecordsForUpload = [];
      this.nombreArchivosMotivo = [];
      this.archivosMotivo = [];
      this.itemsObservaciones = [];
    },

    colorEstado(item) {
      if (item == "En proceso") {
        return "yellow";
      } else {
        return "green";
      }
    },

    notificacionTelegram() {
      let mensaje =
        "SE HA ACTUALIZADO UNA SOLICITUD DE GRABACION DE LLAMADA" +
        "%0A" +
        "Fecha solicitud: " +
        this.fechaSolicitud +
        "%0A" +
        "Fecha asistencia: " +
        this.fechaAsistencia +
        "%0A" +
        "Numero asistencia: " +
        this.numeroAsistencia +
        "%0A" +
        "Nombre asegurado: " +
        this.nombre +
        "%0A" +
        "Placa: " +
        this.placa +
        "%0A" +
        "Marca: " +
        this.marca +
        "%0A" +
        "Modelo: " +
        this.modelo +
        "%0A" +
        "Solicitada por nombre: " +
        this.solicitadaNombre +
        "%0A" +
        "motivo de petición: " +
        this.motivoSolicitud;

      axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatIdGrupo +
            "&text=" +
            mensaje
        )
        .then((response) => {
          //console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });

      axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatIdUsuario +
            "&text=" +
            mensaje
        )
        .then((response) => {
          //console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },

    //Metodos para ver los archivos cargados por quien realizo la solicitud y poder eliminar cada archivo
    verArchivosMotivo: function () {
      let me = this;
      dbStorage
        .ref(
          "SolicitudesGrabaciones/" +
            me.cuenta +
            "/" +
            "ArchivosMotivos" +
            "/" +
            me.numeroAsistencia
        )
        .list()
        .then(function (refImagen) {
          for (var i = 0; i < refImagen.items.length; i++) {
            let aux = refImagen.items[i].location.path.split("/");
            me.nombreArchivosMotivo[i] = aux[4];
          }
          me.descargarArchivosMotivo();
        });
    },
    descargarArchivosMotivo: function () {
      let me = this;
      me.archivosMotivo = [];
      for (var i = 0; i < me.nombreArchivosMotivo.length; i++) {
        let auxNombre = me.nombreArchivosMotivo[i];
        dbStorage
          .ref(
            "SolicitudesGrabaciones/" +
              me.cuenta +
              "/" +
              "ArchivosMotivos" +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.nombreArchivosMotivo[i]
          )
          .getDownloadURL()
          .then(function (url) {
            me.archivosMotivo.push({ url: url, nombre: auxNombre });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    eliminarArchivo: function (item) {
      let me = this;
      dbStorage
        .ref(
          "SolicitudesGrabaciones/" +
            me.cuenta +
            "/" +
            "ArchivosMotivos" +
            "/" +
            me.numeroAsistencia +
            "/" +
            item.nombre
        )
        .delete()
        .then(function () {
          me.$toast.error("Archivo eliminado con exito");
          me.close();
        })
        .catch(function (error) {
          console.log("ERROR", error);
        });
    },
    //Metodos para cargar archivos cuando ya se hizo la solicitud
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
    },
    cargarArchivos: function () {
      let me = this;
      me.overlay = true;
      for (var i = 0; i < me.fileRecordsForUpload.length; i++) {
        dbStorage
          .ref(
            "SolicitudesGrabaciones/" +
              me.cuenta +
              "/" +
              "ArchivosMotivos" +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.fileRecordsForUpload[i].file.name
          )
          .put(me.fileRecordsForUpload[i].file)
          .then(function () {
            me.$toast.info("Archivo(s) cargado(s) con exito!");
            me.overlay = false;
            me.close();
          })
          .catch(function (error) {
            console.log("ERROR", error);
          });
      }
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
        }
      }
    },
  },
};
</script>